// Estado de cuenta de TikTok Shop ("merchant_statement_profit_loss_*.xlsx", hoja "Pedidos"): un renglon por
// pedido + SKU con lo que el vendedor recibe. El encabezado esta en el renglon cuya columna A es
// "ID del pedido" (arriba trae "Descargado el", "Total de transacciones" y una nota).
// Las columnas en rojo del archivo (Descuentos de vendedores ... Costo de envio) ya vienen sumadas en
// "Ingresos por pedidos" (descuento del vendedor y reembolsos) y "Costo de los pedidos" (comisiones,
// tarifas, impuestos y envio): neto = ingresos + costo = "Margen neto de pedidos".
// Regresa los renglones para POST /articulosPedidoEstadoCuentaTikTok (montos con el signo del archivo),
// o null si el archivo no es el estado de cuenta.

const num = (v) => {
  const n = parseFloat(String(v == null ? "" : v).replace(/[^0-9.-]/g, ""));
  return isNaN(n) ? 0 : n;
};

export const COLUMNAS_OBLIGATORIAS_TIKTOK = [
  "ID del SKU",
  "Ingresos por pedidos",
  "Costo de los pedidos",
  "Artículos vendidos",
];

export function filasEstadoCuentaTikTok(raw) {
  const iHead = raw.findIndex((r) => String(r[0]).trim() === "ID del pedido");
  if (iHead < 0) return null;
  const head = raw[iHead].map((h) => String(h).trim());
  const faltan = COLUMNAS_OBLIGATORIAS_TIKTOK.filter((c) => !head.includes(c));
  if (faltan.length) throw new Error(`Al estado de cuenta de TikTok le faltan columnas: ${faltan.join(", ")}`);
  const v = (r, c) => (head.includes(c) ? r[head.indexOf(c)] : "");
  const hayMargen = head.includes("Margen neto de pedidos");

  return raw
    .slice(iHead + 1)
    .filter((r) => /^\d{10,}$/.test(String(r[0]).trim()))
    .map((r) => ({
      pedido: String(r[0]).trim(),
      idSku: String(v(r, "ID del SKU")).trim(),
      estado: String(v(r, "Estado del pedido") || "").trim(),
      unidades: num(v(r, "Artículos vendidos")),
      ingresos: num(v(r, "Ingresos por pedidos")),
      costo: num(v(r, "Costo de los pedidos")),
      margen: hayMargen ? num(v(r, "Margen neto de pedidos")) : null,
      isr: num(v(r, "ISR")) + num(v(r, "Impuesto cedular")),
      iva: num(v(r, "IVA")),
      envio:
        num(v(r, "TikTok Shop cubre el costo de envío")) +
        num(v(r, "Tarifa de envío del cliente")) +
        num(v(r, "Tarifa de envío reembolsada del cliente")) +
        num(v(r, "Costo de envío de devoluciones")) +
        num(v(r, "Costo de envío")),
    }));
}
